// extracted by mini-css-extract-plugin
export default {"header":"style_header__3RAeC","subheader":"style_subheader__OCyuQ"};